'use strict';

//wbApp.config(function ($provide) {
//    $provide.decorator('taOptions', ['taRegisterTool', '$delegate', function (taRegisterTool, taOptions) {
//        // $delegate is the taOptions we are decorating
//        // register the tool with textAngular
        
//        taRegisterTool('colourRed', {
//            display: '<button type="button" wb-color-picker class="btn btn-default" ng-model="wbExt.fontColor" id="text-angular-font-color"></button>',
//            // iconclass: "fa fa-square red",
//            action: function (deffered) {
//                var btn =  angular.element('#text-angular-font-color').scope();
//                var me = this;
//                if (me.wbExt) {
//                    me.wbExt.deffered = deffered;
//                }
//                else {
//                    me.wbExt = { fontColor: '', deffered: deffered };
//                    btn.$watch('wbExt.fontColor', function (newVal) {
//                        if (newVal !== '') {
//                            me.$editor().wrapSelection('forecolor', 'red');
//                        }
//                        me.wbExt.deffered.resolve();
//                    });
//                }
             
//                return false;
//            }
//        });
//        // add the button to the default toolbar definition
//        taOptions.toolbar[1].push('colourRed');
//        return taOptions;
//    }]);
//});

wbApp.directive('wbHtmlEditor', ['$window', '$timeout',
    function ($window, $timeout) {
        return {
            restrict: 'A',
            require: '^ngModel',
            replace: true,
            template: '<div text-angular ta-toolbar="[[\'html\'],[\'h1\',\'h2\',\'h3\', \'h4\', \'h5\', \'h6\', \'p\', \'pre\', \'quote\'],[\'bold\',\'italics\', \'underline\', \'ul\', \'ol\', \'justifyLeft\', \'justifyCenter\', \'justifyRight\'], [\'indent\', \'outdent\'], [\'undo\', \'redo\', \'clear\'], [\'insertImage\', \'insertLink\', \'insertVideo\']]" ></div>',
            link: function (scope, element, attrs, ngModel) {

                function resizeEditor() {
                    var parent = element.parent();
                    var prev = element.prev();
                    var scrollWindow = element.find('.ta-scroll-window');
                    var taBind = element.find('.ta-bind');
                    var toolbar = element.find('.ta-toolbar');

                    var newHeight = parent.height() - prev.outerHeight() - toolbar.outerHeight() - 1;
                    scrollWindow.height(newHeight);
                    taBind.css("min-height", newHeight + 'px');
                }

                angular.element($window).bind('resize', resizeEditor);

                $timeout(function () { resizeEditor(); });
            }
        }
    }]);